import { useLanguageContext } from "../../../../context/LanguageContext";
import { useQuestionnaireEditRouteValidator } from "../../../validators/questionnaires/QuestionnaireEditRouteValidator";
import useQuestionnaireEditRouteConfig from "../QuestionnaireEditRouteConfig";
import { RouteConfig } from "../../RouteConfig";
import QuestionPage from "../../../../pages/questionnaires/questionnaire/question/QuestionPage";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useQuestionEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath(
      "/dashboard/questionnaires/:questionnaire/questions/:question/edit"
    )
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.question"),
        },
      ])
    )
    .setValidator(useQuestionnaireEditRouteValidator())
    .setPage(<QuestionPage />)
    .setParent(useQuestionnaireEditRouteConfig());
}

export default useQuestionEditRouteConfig;
